// extracted by mini-css-extract-plugin
export var tabs2Level = "tabs-2-level_XfpP3th1Y87mclTNPEmq";